export default "__VITE_ASSET__CLnlfVo1__"